import { RIBBON_STORAGE_KEY } from "src/hooks/use-ribbon";
import { getStorageJSON } from "./localStorage";

type HasNewAlertsProps = {
  gender: string;
  alerts: string[];
};

export function compareAlerts({ gender, alerts }: HasNewAlertsProps): boolean {
  const storedAlerts =
    getStorageJSON<Record<string, string[]>>(RIBBON_STORAGE_KEY) || {};

  if (
    !storedAlerts ||
    !storedAlerts[gender] ||
    !storedAlerts[gender].length ||
    !alerts ||
    !alerts.length
  ) {
    return false;
  }

  if (alerts.length !== storedAlerts[gender].length) {
    return false;
  }

  return JSON.stringify(alerts) === JSON.stringify(storedAlerts[gender]);
}
